import React from 'react'

import Tooltip from '../Tooltip'

interface Props {
    onClick: () => void
    disabled: boolean
}

const Copy: React.FC<Props> = props => (
    <Tooltip content="Copied!" direction="left" allowed={!props.disabled} >
        <svg onClick={props.onClick} className={`w-6 h-6 text-gray-300 ${props.disabled ? 'opacity-50 cursor-default' : 'cursor-pointer hover:text-red-650'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" /></svg>
    </Tooltip>
)

export default Copy